import { SubmitHandler, useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { zodResolver } from "@hookform/resolvers/zod"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { useOpenNewWindow } from "@/modules/patients/detail/progress-note/hooks/useOpenNewWindow"
import {
  DummyConnectVideoForm,
  DummyConnectVideoSchema,
} from "@/modules/video-call/components/dummy-call/dummy-connect-video-schema"
import { SofiaEnvironment } from "@/sofia-environment"

interface DummyConnectVideoCallDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const DummyConnectVideoCallDialog = ({ open, onOpenChange }: DummyConnectVideoCallDialogProps) => {
  const { t } = useTranslation()

  const openNewWindow = useOpenNewWindow()

  const {
    register,
    handleSubmit,
    formState: { errors: formErrors },
  } = useForm<DummyConnectVideoForm>({
    resolver: zodResolver(DummyConnectVideoSchema),
  })

  const handleClickDummyButton = (sid: string, token: string) => {
    if (!SofiaEnvironment.AllowDebugFeatures) {
      return
    }

    setTimeout(() => {
      openNewWindow(`/dummy-video-call?sid=${sid}&token=${token}`, "sofia-dummy-video-call")
    }, 2000)
  }
  const onSubmit: SubmitHandler<DummyConnectVideoForm> = (data) => {
    handleClickDummyButton(data.roomSid, data.patientToken)
    onCancel()
  }

  const onCancel = () => {
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onCancel}>
      <DialogContent variant="small">
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogHeader>
            <DialogTitle>Connect to video call</DialogTitle>
          </DialogHeader>
          <div className="grid gap-4 px-6 py-2">
            <Input
              {...register("roomSid")}
              label="Room Sid"
              required
              error={formErrors.roomSid?.message}
              translateError
              errorClasses="truncate"
            />
            <Input
              {...register("patientToken")}
              label="Patient Token"
              required
              error={formErrors.patientToken?.message}
              translateError
              errorClasses="truncate"
            />
          </div>
          <DialogFooter>
            <Button variant="secondary" onClick={onCancel} type="button">
              {t("common.button.cancel")}
            </Button>
            <Button>{t("common.button.ok")}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}

export { DummyConnectVideoCallDialog }
